import { Pipe } from "@angular/core";
import { PipedTableColumn } from './piped-table-column';

export class TagTableColumn extends PipedTableColumn {
    constructor(name: string, label: string, path: string, pipe: Pipe | string) {
        super(name, label, path, pipe);
    }
}
